import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// import InventoryFilter from "./InventoryFilter";

export default function InventoryHeader() {
    return (
        <Grid container spacing={2}>
            <Grid item md={4} sm={12}>
                <Typography variant={'h5'}>
                    PRODUCT TO PURCHASE...
                </Typography>
            </Grid>
            <Grid item xs={8}>
                
                {/*<InventoryFilter/>*/}
            </Grid>
        </Grid>
    )
}